import { Badge, Breadcrumb, Flex, Typography } from 'antd';
import { FC, ReactNode } from 'react';
import { HouseFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { AppRoutes } from '@/common/interfaces';

import { PageNode } from '@/modules/Pages';

interface Props {
  pageNodeId: PageNode['id'];
  pageNodeSiteId: PageNode['site']['id'];
  pageNodeBreadcrumb: PageNode['breadcrumb'];
}

export const PageNodesBeadcrumb: FC<Props> = ({ pageNodeId, pageNodeBreadcrumb, pageNodeSiteId }) => {
  return (
    <>
      <Breadcrumb
        className="page-node-breadname"
        items={
          pageNodeBreadcrumb.map(({ id, extension, slug }) => ({
            key: id,
            title: <PageNodesBreadcrumbItem
              id={ id }
              isCurrent={ pageNodeId === id }
              isHome={ slug === '/' }
              siteId={ pageNodeSiteId }
              slug={ slug }
              extension={ extension }
            />
          }))
        }
        separator={ '/' }
      />
    </>
  );
};

interface ItemProps {
  id: PageNode['id'];
  siteId: PageNode['site']['id'];
  slug: PageNode['slug'];
  isHome: PageNode['isHome'];
  extension: PageNode['extension']
  isCurrent: boolean;
}

const PageNodesBreadcrumbItem: FC<ItemProps> = ({ id, isCurrent, isHome, siteId, slug, extension }) => {
  const extBadge = extension && <Badge style={{ marginBottom: -4 }} size="small" count={ `.${ extension }` }/>;
  const innerWrapper = (inner: ReactNode) => (
    <Flex align="center" gap={ 2 }>
      { inner }
      { extBadge }
    </Flex>
  );
  const link = (content: ReactNode) => (
    <Link to={ AppRoutes.PageNodesById.replace(':siteId', siteId).replace(':nodeId', id) }>
      { content }
    </Link>
  );

  if (isHome) {
    return isCurrent ? (
      innerWrapper(<HouseFill size={ 20 }/>)
    ) : (
      link(innerWrapper(<HouseFill size={ 20 }/>))
    );
  } else {
    return (
      <Typography.Title style={{ margin: 0 }} level={ 4 }>
        { isCurrent ? (
          innerWrapper(slug)
        ) : (
          link(innerWrapper(slug))
        ) }
      </Typography.Title>
    );
  }
};
